import { NOBODY } from './ganttSegments'

/** Returns the Monday of the week containing `date`, using the local calendar date. */
export function getMondayOf(date: Date): Date {
  const d = new Date(date)
  const day = d.getDay()
  d.setDate(d.getDate() + (day === 0 ? -6 : 1 - day))
  d.setHours(0, 0, 0, 0)
  return d
}

export function getMonthStart(date: Date): Date {
  const d = new Date(date)
  d.setDate(1)
  d.setHours(0, 0, 0, 0)
  return d
}

export function daysInMonth(date: Date): number {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
}

const PALETTE_HUES = [217, 196, 172, 145, 258, 230, 36, 186]

function userHue(name: string): number {
  let h = 5381
  for (let i = 0; i < name.length; i++) {
    h = ((h << 5) + h) ^ name.charCodeAt(i)
    h = h | 0
  }
  const hue = PALETTE_HUES[Math.abs(h) % PALETTE_HUES.length]
  if (hue === undefined) throw new Error('Invalid calendar colour index')
  return hue
}

export function segmentBg(name: string): string {
  if (!name || name === NOBODY) return '#e5e7eb'
  return `hsl(${userHue(name)}, 65%, 63%)`
}

export function segmentText(name: string): string {
  if (!name || name === NOBODY) return '#9ca3af'
  return `hsl(${userHue(name)}, 75%, 18%)`
}
